import { render, staticRenderFns } from "./KinvaDocCreate.vue?vue&type=template&id=0a20bbab&scoped=true"
import script from "./KinvaDocCreate.vue?vue&type=script&lang=js"
export * from "./KinvaDocCreate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a20bbab",
  null
  
)

export default component.exports